/* 外部リソースの非同期 readiness retry を管理する */
(() => {
  if (window.AuremeReadyRetry) return;

  function createScheduler({ intervalMs, maxRetryCount }) {
    let retryTimer = null;

    function clear() {
      if (!retryTimer) return;

      window.clearTimeout(retryTimer);
      retryTimer = null;
    }

    function schedule({ tryReady, onRetry, retryCount = 0 }) {
      if (tryReady()) {
        clear();
        return true;
      }

      /*
       * 同じ scheduler に複数の retry 要求が重なっても、待機中 timer は 1 本に保つ。
       * 呼び出し元側の retryCount が進む前に二重実行されるのを防ぐ。
       */
      if (retryCount >= maxRetryCount || retryTimer) return false;

      retryTimer = window.setTimeout(() => {
        retryTimer = null;
        onRetry(retryCount + 1);
      }, intervalMs);

      return false;
    }

    return {
      clear,
      schedule,
    };
  }

  window.AuremeReadyRetry = {
    createScheduler,
  };
})();
